import React, { useRef } from "react";
import { CheckCircle2, MoreHorizontal, Trash2 } from "lucide-react";
import { cn } from "../utils";
import { FilterTabLabel } from "./filter-tabs";
import { PortaledDropdown } from "./portaled-dropdown";

const MENU_WIDTH = 176;

export function RowActionMenu({
  isOpen,
  onToggle,
  menuRef: _menuRef,
  busy,
  menuTitle,
  statusOptions = [],
  currentStatus,
  onStatusChange,
  onDelete,
  statusLabelFn,
  deleteLabel,
}) {
  const triggerRef = useRef(null);

  const handleClose = () => {
    if (isOpen) onToggle();
  };

  return (
    <div className="relative" ref={triggerRef}>
      <button
        type="button"
        onClick={onToggle}
        disabled={busy}
        className={cn(
          "p-1.5 rounded-lg hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-all",
          isOpen ? "opacity-100 bg-gray-100" : "opacity-0 group-hover:opacity-100"
        )}
      >
        <MoreHorizontal className="w-4 h-4" />
      </button>

      <PortaledDropdown
        isOpen={isOpen}
        triggerRef={triggerRef}
        onClose={handleClose}
        width={MENU_WIDTH}
      >
        {menuTitle && statusOptions.length > 0 && (
          <>
            <FilterTabLabel>{menuTitle}</FilterTabLabel>
            {statusOptions.map((st) => (
              <button
                key={st}
                type="button"
                role="menuitem"
                onClick={() => onStatusChange(st)}
                disabled={currentStatus === st}
                className={cn(
                  "w-full text-left px-3 py-1.5 hover:bg-gray-50 flex items-center gap-2",
                  currentStatus === st ? "text-gray-300 cursor-default" : "text-gray-700"
                )}
                style={{ fontSize: "0.8rem" }}
              >
                <span className="w-3.5 h-3.5 flex items-center justify-center shrink-0">
                  {currentStatus === st && <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" />}
                </span>
                {statusLabelFn ? statusLabelFn(st) : st}
              </button>
            ))}
            <div className="my-1 border-t border-gray-100" />
          </>
        )}
        {onDelete && (
          <button
            type="button"
            role="menuitem"
            onClick={onDelete}
            className="w-full text-left px-3 py-1.5 hover:bg-red-50 text-red-600 flex items-center gap-2"
            style={{ fontSize: "0.8rem" }}
          >
            <Trash2 className="w-3.5 h-3.5" /> {deleteLabel}
          </button>
        )}
      </PortaledDropdown>
    </div>
  );
}
